import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertnavComponent from './advertnav.component';

let advertnavModule = angular.module('advertnav', [
  uiRouter
])

.component('advertnav', advertnavComponent)

.name;

export default advertnavModule;
